import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { DdkState } from "../../accountancy/ddk-state";
import { JpkVatState } from "../../accountancy/jpk-vat-state";
import { EppState } from "../../common/epp-state";
import { DocumentVatTableDTO } from "../../document/dto/document-vat-table.dto";
import { KsefReceivedDocumentKind } from "../../ksef/ksef-received-document-kind";
import { PurchaseDocumentGetItemDTO } from "./purchase-document-item.dto";
import { PurchaseDocumentDTO } from "./purchase-document.dto";

export class PurchaseGetDocumentDTO extends PurchaseDocumentDTO {
	public issuedByVatPayer: boolean;
	public totalGrossValue: number;
	public totalNetValue: number;
	public totalBaseCurrencyGrossValue: number;
	public totalBaseCurrencyNetValue: number;
	public adjustedDocumentVersion: string;
	public adjustedDocumentId: number;
    public ddkState: DdkState;
    public eppState: EppState;
    public jpk_vatState?: JpkVatState;
	public ksefHeaderId?: number;
    public ksefHash?: string;
	public ksefCollectiveIdentifier?: string | null;
    @Transform(transformDTODate, { toClassOnly: true }) public dateOfAssigningKsefNumber?: Date;
	public ksefDocumentKind?: KsefReceivedDocumentKind;
	public includesInventoryControl: boolean;
	@Type(() => DocumentVatTableDTO) public vatTable: DocumentVatTableDTO;
	@Type(() => PurchaseDocumentGetItemDTO) public items: PurchaseDocumentGetItemDTO[];
}
